<template>
  <div class="oprationSet">
    <!-- 医生和代表端切换 -->
    <el-tabs
      v-if="!isShowEditComponents"
      v-model="activeName"
      @tab-click="handleTabClick"
      v-loading="oprationSetLoading"
    >
      <el-tab-pane
        v-for="item in tabOptions"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <div class="operation_content">
          <div class="filter-content">
            <el-form inline>
              <el-form-item label="运营位状态:">
                <el-select v-model="status" placeholder="请选择">
                  <el-option
                    v-for="opt in statusOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button type="primary" @click="getFilterList">筛选</el-button>
          </div>
          <div class="title">
            <p class="leftTitle">
              {{ entryTypeText }}运营位
              <!--              <i>({{ onlineCount }}/{{ onLineLimit }})</i>-->
              <i>{{ showCount }}</i>
            </p>
            <div>
              <el-button type="primary" @click="openNewOprationSpace('add')">新建运营位</el-button>
              <el-button plain :disabled="!onlineData.length" v-if="false" @click="clickToSort">
                整体预览
              </el-button>
            </div>
          </div>
          <el-table
            class="my-table"
            :data="filterList"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="styleObj"
          >
            <template slot="empty">
              <!-- 没有数据 -->
              <div class="table-noData">
                <img class="table-noData-img" :src="g_imgSrc.bgWhite" />
                <div class="table-noData-word">暂无相关内容</div>
              </div>
            </template>
            <!-- <el-table-column property="sort" label="排序"></el-table-column> -->
            <el-table-column label="运营内容" width="512">
              <template #default="{ row }">
                <div class="table-item-content">
                  <div class="imgContent">
                    <img :src="row.image_url" alt="" />
                    <p v-if="row.status === 1" class="unplay">下线</p>
                    <p v-if="row.status === 0" class="unplay">待发布</p>
                  </div>
                  <p class="title" :title="item.title">
                    {{ row.title }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="status" label="状态">
              <template #default="{ row }">
                <div>
                  {{ statusMap[row.status] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column property="release_time" label="发布时间">
              <template slot-scope="scope">
                {{
                  scope.row.release_time
                    ? $moment(scope.row.release_time * 1000).format('YYYY-MM-DD HH:mm:ss')
                    : '--'
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :disabled="scope.row.status === 2"
                  @click="openNewOprationSpace('edit', scope.row)"
                >
                  编辑
                </el-button>
                <el-button @click="handleClickPreview(scope.row)" type="text">预览</el-button>
                <el-button @click="handleClickOfflineBanner(scope.row)" type="text">
                  {{ [0, 1].includes(scope.row.status) ? '上线' : '下线' }}
                </el-button>
                <el-button @click="handleClickDelete(scope.row)" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 预览组件 -->
    <Preview
      v-if="previewVisible"
      :enterprise-logo="enterpriseLogo"
      :entry-type="activeName"
      :item-data="currentItem"
      :dialog-form-visible="previewVisible"
      :online-data="onlineData"
      :is-new-item-sort="isNewItemSort"
      :is-can-sort="isCanSort"
      @hideDialog="hidePreviewDialog"
      @clickConfirm="confirmSort"
    />
    <!-- 删除弹窗  -->
    <el-dialog
      class="my-dialog"
      title="确定删除该内容吗？"
      :visible.sync="deleteDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <span style="text-align: center">（删除后内容无法恢复，且运营位失效）</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clickConfirmDelete">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上下线弹窗  -->
    <el-dialog
      :title="[0, 1].includes(currentItem.status) ? '确定上线该内容吗' : '确定下线该内容吗'"
      :visible.sync="statusDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clickConfirmOfflineBanner">确 定</el-button>
      </span>
    </el-dialog>
    <div style="margin-top: 20px; float: right">
      <el-pagination
        style="background-color: #ffffff"
        layout="prev, pager, next"
        :total="pageTotal"
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import Preview from './components/preview'; /* 预览 */
import {
  getCompanyInfoApi /* 获取药企基本信息 */,
  offlineBannerApi,
  deleteBannerApi, // 删除横幅
  getBannerListApi, // 查询横幅列表
  getBannerLimitApi, // 查询排序上限
  updateSortApi,
} from '@/api/releaseManagement';
import { BannerEntryType } from '@/utils/constant';

export default {
  name: 'OperationManagement',
  components: {
    Preview,
  },
  data() {
    return {
      activeName: 'doctor',
      tabOptions: [
        {
          name: 'doctor',
          label: '医生端',
        },
        {
          name: 'deputy',
          label: '代表端',
        },
        {
          name: 'h5',
          label: 'H5渠道',
        },
      ],
      statusMap: {
        0: '待发布',
        1: '下线',
        2: '上线',
      },
      status: 2,
      statusOptions: [
        {
          value: 2,
          label: '已上线',
        },
        {
          value: 1,
          label: '已下线',
        },
        {
          value: 0,
          label: '待发布',
        },
      ],
      currentItem: {},
      oprationList: [], // 运营位数组
      pageSize: 10, // 分页大小
      pageIndex: 1, // 当前页码
      pageTotal: 1, // 总页码数
      filterList: [], // 状态筛选后的列表
      onLineLimit: 4, // 可上线运营位上限，默认为4
      isNewItemSort: false, // 预览是否是上线
      isCanSort: false, // 是否能排序
      oprationSetLoading: true, // loading
      previewVisible: false /* 预览组件是否显示 */,
      enterpriseLogo: '', // 企业logo//
      statusDialogVisible: false, // 上下线弹窗状态
      deleteDialogVisible: false, // 删除弹窗状态
      styleObj: {
        background: '#f5f7fa', // 表头颜色
      },
      sortData: [], // 排序后的数据，从preview组件传来
      isShowEditComponents: false,
      breadcrumb: [
        {
          menu_name: '发布管理',
        },
        {
          menu_name: '运营位管理',
          // menu_path: 'operationManagement',
        },
        {
          menu_name: '医生端',
        },
      ],
    };
  },
  computed: {
    // 入口参数 1-医生端，2-代表端, 3-H5渠道
    entryType() {
      return BannerEntryType[this.activeName].name;
    },
    entryTypeText() {
      return BannerEntryType[this.activeName].text;
    },
    // 已上线数量
    onlineCount() {
      return this.oprationList.filter((item) => item.status === 2).length;
    },
    // 已上线数据
    onlineData() {
      return this.oprationList.filter((item) => item.status === 2);
    },
    showCount() {
      if (this.onLineLimit >= 0) {
        return `(${this.onlineCount}/${this.onLineLimit})`;
      }
      return `(${this.onlineCount}/无限制)`;
    },
  },
  watch: {},
  created() {
    if (this.$route.query.entryType) {
      this.activeName = this.$route.query.entryType;
      this.breadcrumb[2] = {
        menu_name: this.tabOptions.find((tab) => tab.name === this.activeName).label,
      };
      this.breadcrumb.reverse().reverse();
      this.g_breadcrumb(this.breadcrumb);
    } else {
      this.g_breadcrumb(this.breadcrumb);
    }
    // this.querySort();
    this.getOprationList();
    this.getQueryCompanyConfig();
  },
  methods: {
    handleTabClick(tab) {
      const { name } = tab;
      this.breadcrumb[2] = {
        menu_name: this.tabOptions.find((tab) => tab.name === name).label,
      };
      this.breadcrumb.reverse().reverse();
      this.g_breadcrumb(this.breadcrumb);
      this.activeName = name;
      this.status = 2;
      this.getOprationList();
    },
    /**
     * 获取排序上限
     */
    async querySort() {
      try {
        const res = await getBannerLimitApi({
          entry_type: this.entryType,
        });
        // console.log({ res });
        const { limit } = res;
        this.onLineLimit = limit;
      } catch (err) {
        console.log('error', err);
      }
    },
    /**
     * 查询横幅列表
     */
    async getOprationList() {
      this.oprationSetLoading = true;
      getBannerListApi({
        entry_type: this.entryType,
        page_index: this.pageIndex,
        page_size: this.pageSize,
      })
        .then((res) => {
          if (res.banner_list.length) {
            this.oprationList = res.banner_list;
            this.pageTotal = res.total;
          } else {
            this.oprationList = [];
          }
          this.getFilterList();
        })
        .catch((err) => {
          this.$message.error('查询失败');
          console.log('error', err);
        })
        .finally(() => {
          this.oprationSetLoading = false;
        });
      await this.querySort();
    },
    getFilterList() {
      this.filterList = this.oprationList
        .filter((item) => item.status === this.status)
        .sort((a, b) => a.sort - b.sort);
    },
    /**
     *查询企业配置
     */
    async getQueryCompanyConfig() {
      try {
        const res = await getCompanyInfoApi();
        // console.log('企业配置', res);
        this.enterpriseLogo = res.enterprise_logo;
      } catch (err) {
        console.log('error', err);
      }
    },
    // 检查是否符合banner数量限制
    checkBannerLimit(status) {
      if (this.onLineLimit === -1 && this.entryType === 3) {
        return true;
      }
      // 4为医生和代表端的固定数量
      if (['下线', '待发布'].includes(this.statusMap[status]) && 4 <= this.onlineCount) {
        this.$message.warning(
          `已上线${this.onlineCount}个运营位，如需上线新运营位，请先下线无用运营位`,
        );
        return false;
      }
      return true;
    },
    /* 打开 上线/下线 弹窗 */
    handleClickOfflineBanner(row) {
      if (!this.checkBannerLimit(row.status)) {
        return;
      }

      this.currentItem = row;
      // 上线
      if (['下线', '待发布'].includes(this.statusMap[row.status])) {
        this.isNewItemSort = true;
        this.isCanSort = true;
        this.previewVisible = true;
        return;
      }
      // 下线
      this.statusDialogVisible = true;
    },
    /* 确认上下线 */
    async clickConfirmOfflineBanner() {
      try {
        const params = {
          banner_id: this.currentItem.banner_id,
        };
        await offlineBannerApi(params);
        await this.updateSort(this.sortData);
        this.$message.success('操作成功');
        this.getOprationList();
      } catch (err) {
        console.log('error', err);
        this.$message.error('操作失败');
      }
      this.statusDialogVisible = false;
    },
    /* 打开删除弹窗 */
    handleClickDelete(row) {
      this.currentItem = row;
      this.deleteDialogVisible = true;
    },
    /**
     * 确认删除运营位
     */
    async clickConfirmDelete() {
      try {
        const params = {
          banner_id: this.currentItem.banner_id,
        };
        await deleteBannerApi(params);
        this.$message.success('删除成功');
        this.getOprationList();
      } catch (err) {
        this.$message.error('删除失败');
      }
      this.deleteDialogVisible = false;
    },
    /**
     * 整体预览
     */
    clickToSort() {
      this.isCanSort = true;
      this.previewVisible = true;
    },
    /* 打开预览弹窗 */
    handleClickPreview(row) {
      this.currentItem = row;
      this.isNewItemSort = true;
      this.previewVisible = true;
    },
    /* 隐藏预览弹框 */
    hidePreviewDialog() {
      this.isNewItemSort = false;
      this.isCanSort = false;
      this.previewVisible = false;
    },
    /** 排序确定 */
    async confirmSort(data) {
      // 如果是上线排序，则弹出上线确认框
      if (this.isNewItemSort) {
        this.statusDialogVisible = true;
        this.sortData = [...data];
        return;
      }
      await this.updateSort(data, true);
      await this.getOprationList();
    },
    /* 更新排序 */
    async updateSort(data, needMessage = false) {
      try {
        await updateSortApi({
          banner_sort: data,
        });
        needMessage && this.$message.success('操作成功');
        this.hidePreviewDialog();
      } catch (err) {
        console.log('error', err);
        this.$message.error('操作失败');
      }
    },
    /* 新增 / 编辑 运营位 */
    openNewOprationSpace(type = 'add', row = {}) {
      // this.currentItem = row;
      // this.isShowEditComponents = true;
      if (type === 'add') {
        this.g_tourl(`/saas/operationManagement/edit.html?entryType=${this.activeName}`, {});
        return;
      }
      this.g_tourl(
        `/saas/operationManagement/edit.html?entryType=${this.activeName}&bannerId=${row.banner_id}`,
        {},
      );
    },
    editBack(isSaveSuccess) {
      if (isSaveSuccess) {
        this.getOprationList();
      }
      this.isShowEditComponents = false;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getOprationList();
    },
  },
};
</script>
<style lang="scss" scoped>
.oprationSet {
  .operation_content {
    .filter-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      height: 68px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 16px 0;

      .leftTitle {
        font-size: 16px;
        color: #303133;
        line-height: 28px;
      }
    }

    .my-table.el-table {
      min-height: 500px;
      border: 1px solid #ebebeb;
      border-radius: 8px;
      //无数据
      .table-noData {
        width: 100%;
        height: 100%;
        text-align: center;

        .table-noData-img {
          width: 240px;
          height: 192px;
          margin-top: 100px;
        }

        .table-noData-word {
          height: 22px;
          margin-bottom: 80px;
          font-size: 16px;
          color: #909399;
          text-align: center;
        }
      }

      .table-item-content {
        display: flex;
        align-items: center;
        .imgContent {
          margin-right: 10px;
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          width: 160px;
          height: 90px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .unplay {
            width: 100%;
            height: 100%;
            line-height: 90px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-size: 18px;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }

  .my-dialog ::v-deep .el-dialog--center .el-dialog__body {
    text-align: center;
  }
}
</style>
